import { useEffect, useState } from "react";
import { PAYMENT_METHODS, savePayment } from "../../services/adminService";

export default function PaymentModal({ member, period, payment, onClose, onSaved }) {
  const [form, setForm] = useState({
    status: payment?.status || "paid",
    amount: payment?.amount || "",
    method: payment?.method || PAYMENT_METHODS[0],
    reference: payment?.reference || "",
    paidOn: payment?.paidOn || new Date().toISOString().slice(0, 10),
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError("");
    try {
      await savePayment(member, period, form);
      onSaved(form.status === "paid" ? `Payment recorded for ${member.fullName}` : `${member.fullName} marked unpaid`);
    } catch (err) {
      console.error(err);
      setError("Could not save payment. Check your connection and permissions.");
      setSaving(false);
    }
  };

  const paid = form.status === "paid";

  return (
    <div className="na-overlay" onMouseDown={onClose}>
      <form className="na-modal" onMouseDown={(e) => e.stopPropagation()} onSubmit={submit}>
        <h2>Payment — {period}</h2>
        <p className="na-muted">{member.fullName}</p>

        <div className="na-grid">
          <label className="na-span2">
            Status
            <select value={form.status} onChange={set("status")}>
              <option value="paid">Paid</option>
              <option value="unpaid">Unpaid</option>
            </select>
          </label>
          {paid && (
            <>
              <label>
                Amount (KES)
                <input type="number" min="0" value={form.amount} onChange={set("amount")} />
              </label>
              <label>
                Date paid
                <input type="date" value={form.paidOn} onChange={set("paidOn")} />
              </label>
              <label>
                Method
                <select value={form.method} onChange={set("method")}>
                  {PAYMENT_METHODS.map((m) => (
                    <option key={m}>{m}</option>
                  ))}
                </select>
              </label>
              <label>
                Reference
                <input value={form.reference} onChange={set("reference")} placeholder="M-Pesa code, receipt no." />
              </label>
            </>
          )}
        </div>

        {error && <p className="na-error">{error}</p>}

        <div className="na-modal-actions">
          <button type="button" className="na-btn" onClick={onClose}>
            Cancel
          </button>
          <button type="submit" className="na-btn na-btn-primary" disabled={saving}>
            {saving ? "Saving…" : "Save payment"}
          </button>
        </div>
      </form>
    </div>
  );
}
